module.exports = __webpack_public_path__ + "img/edit.7405a28d.svg";